import { Panel, PanelLabel } from "@/components/PageHeader";
import { AccountActions, type AccountActionHandlers } from "@/components/accounts/AccountActions";
import { accountKindLabel, type Account } from "@/lib/finance";
import { initials, money } from "@/lib/format";
import { FxBalance } from "@/components/accounts/FxBalance";

interface Props { title: string; testId: string; empty: string; accounts: Account[]; total: number }

export function AssetsCard({ title, testId, empty, accounts, total, ...handlers }: Props & AccountActionHandlers) {
  return (
    <Panel testId={testId}>
      <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
        <PanelLabel>{title}</PanelLabel>
        <p className="figure-lg text-[#16294D]" data-testid={`${testId}-total`}>{money(total)}</p>
      </div>
      <div className="mt-5 hidden grid-cols-[44px_1fr_140px_150px_32px] gap-3 rounded-lg bg-[#F4F5F7] px-4 py-2.5 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500 sm:grid">
        <span /><span>Cuenta</span><span>Tipo</span><span className="text-right">Saldo</span><span />
      </div>
      {accounts.length === 0 && <p className="py-8 text-sm text-slate-500" data-testid={`${testId}-empty`}>{empty}</p>}
      <ul className="divide-y divide-[#DDE1E8]">
        {accounts.map((a) => (
          <li key={a.id} className="grid grid-cols-[40px_1fr_auto_28px] items-center gap-3 px-1 py-3.5 sm:grid-cols-[44px_1fr_140px_150px_32px] sm:px-4" data-testid={`asset-row-${a.id}`}>
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#F4F5F7] text-xs font-bold text-[#1B2A4A]">{initials(a.name)}</span>
            <div className="min-w-0">
              <p className="break-words font-semibold leading-snug text-[#1B2A4A]">{a.name}</p>
              <p className="break-words text-xs text-slate-500 sm:hidden">{accountKindLabel(a)}{a.institution ? ` · ${a.institution}` : ""}</p>
              {a.institution && <p className="hidden truncate text-xs text-slate-400 sm:block">{a.institution}</p>}
            </div>
            <span className="hidden text-sm text-slate-600 sm:block">{accountKindLabel(a)}</span>
            <FxBalance a={a} className="text-right" />
            <AccountActions account={a} {...handlers} />
          </li>
        ))}
      </ul>
    </Panel>
  );
}
